// PRD.275 — Elia AI Assistant Drawer (Phase 1, UI only).
//
// Elia "is typing" state (FR-13): three dots in a neutral bubble beside the
// avatar, plus visually-hidden status text for screen readers. Honors
// prefers-reduced-motion.

import { ELIA_COLORS } from './elia-theme';
import { EliaAvatar } from './EliaAvatar';
import { usePrefersReducedMotion } from './useEliaLayout';

export function EliaTypingIndicator() {
  const reducedMotion = usePrefersReducedMotion();

  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
      <EliaAvatar size={28} />
      <div
        style={{
          background: ELIA_COLORS.neutralSurface,
          padding: '12px 16px',
          borderRadius: '16px 16px 16px 6px',
          display: 'flex',
          alignItems: 'center',
          gap: 4,
        }}
      >
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            style={{
              width: 6,
              height: 6,
              borderRadius: '9999px',
              background: ELIA_COLORS.textFaint,
              animation: reducedMotion
                ? undefined
                : `elia-typing-bounce 1.2s ${i * 0.15}s infinite ease-in-out`,
              opacity: reducedMotion ? 0.6 : undefined,
            }}
          />
        ))}
      </div>
      <span
        role="status"
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: 'hidden',
          clip: 'rect(0 0 0 0)',
          whiteSpace: 'nowrap',
          border: 0,
        }}
      >
        Elia AI is typing
      </span>
      <style>{`
        @keyframes elia-typing-bounce {
          0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
          30% { transform: translateY(-4px); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
